/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Inline_Default_DescInputs */

const en_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick, so you can manage your registrations later.`)
};

const es_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es rápido, y te deja manejar tus inscripciones después.`)
};

const de_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnell, damit Sie Ihre Anmeldungen später verwalten können.`)
};

const zh_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`很快就好，方便你日后管理报名。`)
};

const ar_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بسرعة، حتى تتمكّن من إدارة تسجيلاتك لاحقاً.`)
};

const fr_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapide, pour que vous puissiez gérer vos inscriptions plus tard.`)
};

const vi_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhanh thôi, để bạn quản lý đăng ký sau này.`)
};

const sw_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haraka, ili uweze kudhibiti usajili wako baadaye.`)
};

const th_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รวดเร็ว เพื่อให้คุณสามารถจัดการการลงทะเบียนของคุณได้ในภายหลัง`)
};

const bs_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brzo je, a kasnije možete upravljati svojim upisima.`)
};

const ja_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すぐに完了し、後から申し込み内容を管理できます。`)
};

const ko_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`금방 끝나며, 나중에 신청 내역을 관리할 수 있습니다.`)
};

const pt_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É rápido, e assim você pode gerenciar suas inscrições depois.`)
};

const it_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È questione di un attimo, e potrai gestire le tue iscrizioni in seguito.`)
};

const sv_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det går snabbt, och du kan hantera dina anmälningar senare.`)
};

const nl_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snel, zodat je je inschrijvingen later kunt beheren.`)
};

const da_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det går hurtigt, så du senere kan administrere dine tilmeldinger.`)
};

const nb_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det går raskt, så du kan administrere påmeldingene dine senere.`)
};

const fi_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nopeasti, jotta voit hallita ilmoittautumisiasi myöhemmin.`)
};

const pl_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybko, żebyś mógł zarządzać rejestracjami później.`)
};

const ru_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это быстро, и позже вы сможете управлять своими записями.`)
};

const tr_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı, böylece kayıtlarınızı daha sonra yönetebilirsiniz.`)
};

const hi_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बस एक पल, ताकि आप बाद में अपने पंजीकरण प्रबंधित कर सकें।`)
};

const id_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cepat, sehingga Anda dapat mengelola pendaftaran nanti.`)
};

const ms_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantas, supaya anda boleh mengurus pendaftaran anda kemudian.`)
};

const cs_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je to rychlé a své registrace pak můžete spravovat později.`)
};

const el_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γρήγορα, ώστε να μπορείτε να διαχειρίζεστε τις εγγραφές σας αργότερα.`)
};

const he_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`זה מהיר, וכך תוכלו לנהל את ההרשמות שלכם בהמשך.`)
};

const af_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinnig, sodat jy jou registrasies later kan bestuur.`)
};

const hu_auth_inline_default_desc = /** @type {(inputs: Auth_Inline_Default_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyors, így később kezelheti a jelentkezéseit.`)
};

/**
* | output |
* | --- |
* | "Quick, so you can manage your registrations later." |
*
* @param {Auth_Inline_Default_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_inline_default_desc = /** @type {((inputs?: Auth_Inline_Default_DescInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Inline_Default_DescInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_inline_default_desc(inputs)
	if (locale === "de") return de_auth_inline_default_desc(inputs)
	if (locale === "zh") return zh_auth_inline_default_desc(inputs)
	if (locale === "ar") return ar_auth_inline_default_desc(inputs)
	if (locale === "fr") return fr_auth_inline_default_desc(inputs)
	if (locale === "vi") return vi_auth_inline_default_desc(inputs)
	if (locale === "sw") return sw_auth_inline_default_desc(inputs)
	if (locale === "th") return th_auth_inline_default_desc(inputs)
	if (locale === "bs") return bs_auth_inline_default_desc(inputs)
	if (locale === "ja") return ja_auth_inline_default_desc(inputs)
	if (locale === "ko") return ko_auth_inline_default_desc(inputs)
	if (locale === "pt") return pt_auth_inline_default_desc(inputs)
	if (locale === "it") return it_auth_inline_default_desc(inputs)
	if (locale === "sv") return sv_auth_inline_default_desc(inputs)
	if (locale === "nl") return nl_auth_inline_default_desc(inputs)
	if (locale === "da") return da_auth_inline_default_desc(inputs)
	if (locale === "nb") return nb_auth_inline_default_desc(inputs)
	if (locale === "fi") return fi_auth_inline_default_desc(inputs)
	if (locale === "pl") return pl_auth_inline_default_desc(inputs)
	if (locale === "ru") return ru_auth_inline_default_desc(inputs)
	if (locale === "tr") return tr_auth_inline_default_desc(inputs)
	if (locale === "hi") return hi_auth_inline_default_desc(inputs)
	if (locale === "id") return id_auth_inline_default_desc(inputs)
	if (locale === "ms") return ms_auth_inline_default_desc(inputs)
	if (locale === "cs") return cs_auth_inline_default_desc(inputs)
	if (locale === "el") return el_auth_inline_default_desc(inputs)
	if (locale === "he") return he_auth_inline_default_desc(inputs)
	if (locale === "af") return af_auth_inline_default_desc(inputs)
	if (locale === "hu") return hu_auth_inline_default_desc(inputs)
	return en_auth_inline_default_desc(inputs)
});